export default {
      id: "oc-data-empty-usage",
      viewBox: "0 0 1763 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-data-empty",
      toString: function () {
        return this.url;
      }
    }